<label *ngIf="label">{{ label | transloco }}</label>
<nz-input-group
  nzSearch
  [nzSize]="inputSize">
  <input
    nz-input
    #input
    [(ngModel)]="inputValue"
    [nzAutocomplete]="auto"
    [placeholder]="placeholder"
    (blur)="blured.emit()"
    (click)="focused.emit()"
    (input)="onInput($event)"
    (keyup.enter)="onInputEnter()" />
</nz-input-group>

<nz-autocomplete #auto>
  <nz-auto-option
    *ngFor="let option of options"
    [nzLabel]="(optionLabelKey ? getTypedLabel(option) : getLabel(option)) | transloco"
    [nzValue]="optionValueKey ? getTypedValue(option) : option"
    (click)="optionSelected.emit(optionValueKey ? getTypedValue(option) : option)">
    <ng-container
      *ngIf="autocompleteOptionTemplateRef; else defaultOption"
      [ngTemplateOutlet]="autocompleteOptionTemplateRef"
      [ngTemplateOutletContext]="{ $implicit: option }"></ng-container>

    <ng-template #defaultOption>
      <span>{{ (optionLabelKey ? getTypedLabel(option) : getLabel(option)) | transloco }}</span>
    </ng-template>
  </nz-auto-option>
</nz-autocomplete>
